export default __webpack_public_path__ + "static/media/bonus-05.130bf4ea.png";